import { styled } from '@mui/material/styles';
import ResourceFullListTable, { IColumn } from '../components/ResourceFullListTable';
import { IFilterField } from 'models/types';
import { AuditLogSummaryDto } from 'models/dtoTypes';
import { GetAuditLogSummary } from 'services/openapiClient';
import { useTranslation } from 'react-i18next';

const PREFIX = 'AuditLogSummaryListPage';

const classes = {
  root: `${PREFIX}-root`,
  demo: `${PREFIX}-demo`,
};

const Root = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(5),
  width: '100%',

  [`&.${classes.demo}`]: {
    backgroundColor: theme.palette.background.paper,
  },
}));

const columns: IColumn<AuditLogSummaryDto>[] = [
  {
    label: 'Event',
    dataIndex: 'eventName',
  },
  {
    label: 'Count',
    dataIndex: 'count',
  },
];

const filterSchema: IFilterField[] = [
  {
    label: 'Action Name',
    name: 'actionName',
    widget: 'text',
  },
  {
    label: 'Period',
    name: 'createdMonth',
    widget: 'monthPicker',
  },
];

export default function AuditLogSummaryListPage(): JSX.Element {
  const { t } = useTranslation('default');

  return (
    <Root>
      <h2>{t('my-organisation-dashboard')}</h2>
      <ResourceFullListTable
        filterSchema={filterSchema}
        columns={columns}
        onFetch={GetAuditLogSummary}
        defaultSort={{
          sortColumn: 'created',
          isDesc: true,
        }}
      />
    </Root>
  );
}
